import { Badge } from '@change/ds-core-ui';
import { CheckIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core/react/i18n';

import type { NormalizedDecisionMaker } from '../../types';

export const ResponseBadge: React.FC<{ response: NormalizedDecisionMaker['response'] }> = ({ response }) => {
	const { translate } = useI18n();

	return response?.message ? (
		<Badge
			label={translate('corgi.petition_gamma.decision_makers_v2.response_status.responded')}
			variant="success"
			emphasis="weaker"
			className="w-fit"
			leadingIcon={<CheckIcon />}
		/>
	) : (
		<Badge
			label={translate('corgi.petition_gamma.decision_makers_v2.response_status.not_responded')}
			variant="neutral"
			emphasis="weaker"
			className="w-fit"
		/>
	);
};
